import { render, staticRenderFns } from "./AltaTecnicoBase.vue?vue&type=template&id=4b685166&"
import script from "./AltaTecnicoBase.vue?vue&type=script&lang=ts&"
export * from "./AltaTecnicoBase.vue?vue&type=script&lang=ts&"
import style0 from "./AltaTecnicoBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b685166', component.options)
    } else {
      api.reload('4b685166', component.options)
    }
    module.hot.accept("./AltaTecnicoBase.vue?vue&type=template&id=4b685166&", function () {
      api.rerender('4b685166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/AltaTecnico/AltaTecnicoBase.vue"
export default component.exports